import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  fontSizes, lineHeights, breakpoints,
}: Theme) => ({
  paragraph: {
    margin: '0 0 0.5rem',
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    [breakpoints.up('sm')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
  contentStyles: {
    '&&': {
      flexDirection: 'column',
    },
  },
}));
